import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { Button, ButtonGroup } from 'reactstrap';

import { APIConfig } from 'src/config';
import {
  FEATURE_INHIBIT_COMMUNITY_TRADES,
  FEATURE_INHIBIT_CONTRACTED_TRADES,
  FEATURE_INHIBIT_NOMINATED_TRADES,
  LIST_FILTER_ALL,
  TRADE_DIRECTION_BUY, TRADE_DIRECTION_SELL,
  TRADE_TYPE_COMMUNITY, TRADE_TYPE_CONTRACTED, TRADE_TYPE_NOMINATED, TRADE_TYPE_RESIDUAL,
} from 'src/util/constants';

/**
 * Filter component for the trade list table
 * @param {object} root0
 * @param {object} root0.filter - object contains tradeDirection and tradeType
 * @param {Function} root0.filterFunc - update the filter selection
 * @returns {React.ReactComponentElement} - TradeListFilters component
 */
function TradeListFilters({
  filter, filterFunc,
}) {
  const filterIncludes = (key, value) => (filter && filter[key] && filter[key].includes(value));
  const intl = useIntl();

  const filterAllLabel = intl.formatMessage({ id: 'trade.trade_list.trade_list_filters.all.label', defaultMessage: 'All' });
  const filterBuyLabel = intl.formatMessage({ id: 'trade.trade_list.trade_list_filters.buy.label', defaultMessage: 'Buy' });
  const filterSellLabel = intl.formatMessage({ id: 'trade.trade_list.trade_list_filters.sell.label', defaultMessage: 'Sell' });
  const filterContractedLabel = intl.formatMessage({ id: 'trade.trade_list.trade_list_filters.contracted.label', defaultMessage: 'Contracted' });
  const filterNominatedLabel = intl.formatMessage({ id: 'trade.trade_list.trade_list_filters.nominated.label', defaultMessage: 'Peer-to-peer' });
  const filterCommunityLabel = intl.formatMessage({ id: 'trade.trade_list.trade_list_filters.community.label', defaultMessage: 'Community' });
  const filterRetailerDefaultLabel = intl.formatMessage({ id: 'trade.trade_list.trade_list_filters.retailer_default.label', defaultMessage: 'Retailer default' });

  return (
    <>
      <ButtonGroup className="me-2 mb-2">
        <Button size="sm" className="btn btn-darken trades-history-all" active={filter.direction.length === 0 && filter.type.length === 0} onClick={() => filterFunc(null, LIST_FILTER_ALL)}>
          {filterAllLabel}
        </Button>
      </ButtonGroup>
      <ButtonGroup className="me-2 mb-2">
        <Button size="sm" className="btn btn-darken trades-history-buy" active={filterIncludes('direction', TRADE_DIRECTION_BUY)} onClick={() => filterFunc('direction', TRADE_DIRECTION_BUY)}>
          {filterBuyLabel}
        </Button>
        <Button size="sm" className="btn btn-darken trades-history-sell" active={filterIncludes('direction', TRADE_DIRECTION_SELL)} onClick={() => filterFunc('direction', TRADE_DIRECTION_SELL)}>
          {filterSellLabel}
        </Button>
      </ButtonGroup>

      <ButtonGroup className="me-2 mb-2">
        {!APIConfig().feature(FEATURE_INHIBIT_CONTRACTED_TRADES) && (
          <Button size="sm" className="btn btn-darken trades-history-contracted" active={filterIncludes('type', TRADE_TYPE_CONTRACTED)} onClick={() => filterFunc('type', TRADE_TYPE_CONTRACTED)}>
            {filterContractedLabel}
          </Button>
        )}
        {!APIConfig().feature(FEATURE_INHIBIT_NOMINATED_TRADES) && (
          <Button size="sm" className="btn btn-darken trades-history-nominated" active={filterIncludes('type', TRADE_TYPE_NOMINATED)} onClick={() => filterFunc('type', TRADE_TYPE_NOMINATED)}>
            {filterNominatedLabel}
          </Button>
        )}
        {!APIConfig().feature(FEATURE_INHIBIT_COMMUNITY_TRADES) && (
          <Button size="sm" className="btn btn-darken trades-history-community" active={filterIncludes('type', TRADE_TYPE_COMMUNITY)} onClick={() => filterFunc('type', TRADE_TYPE_COMMUNITY)}>
            {filterCommunityLabel}
          </Button>
        )}
        <Button size="sm" className="btn btn-darken trades-history-default" active={filterIncludes('type', TRADE_TYPE_RESIDUAL)} onClick={() => filterFunc('type', TRADE_TYPE_RESIDUAL)}>
          {filterRetailerDefaultLabel}
        </Button>
      </ButtonGroup>
    </>
  );
}

TradeListFilters.propTypes = {
  filter: PropTypes.shape({
    direction: PropTypes.arrayOf(PropTypes.string),
    type: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  filterFunc: PropTypes.func.isRequired,
};
export default TradeListFilters;
